// TODO: set routing between view real time interactions and view all interactions
function routeByURL (pageName) {
  // cater situation where user tries to access by typing the URL from other pages
  // cater situation where user click back/forward button which leads back to one of report pages
  var pageNo
  if (window.location.hash.slice(window.location.hash.indexOf('=') + 1) === pageName) {
    pageNo = 1
  } else if (!isNaN(window.location.hash.slice(window.location.hash.indexOf('=') + 1))) {
    pageNo = Number(window.location.hash.slice(window.location.hash.indexOf('=') + 1))
  }
  return pageNo
}

function checkURLChanges (pageName) {
  // check if user clicks back button
  var innerDocClick = null
  document.onmouseover = function() {
    innerDocClick = true
  }
  document.onmouseleave = function() {
    innerDocClick = false
  }
  // Detect if there is any url changes
  window.addEventListener('hashchange', function(event) {
    if (innerDocClick === false) {
      // check if the url ends with #/reports
      if (window.location.hash.slice(window.location.hash.indexOf('=') + 1) === pageName && document.getElementsByClassName('pagination-area')[0]) {
        document.getElementsByClassName('pagination-area')[0].__vue__.currentPage = 1
        // check if the url ends with a page number
      } else if (!isNaN(window.location.hash.slice(window.location.hash.indexOf('=') + 1)) && document.getElementsByClassName('pagination-area')[0]) {
        document.getElementsByClassName('pagination-area')[0].__vue__.currentPage = Number(window.location.hash.slice(window.location.hash.indexOf('=') + 1))
      }
      // check if user is at one of the page number and access the report page from the navbar
    } else {
      if (window.location.hash.slice(window.location.hash.indexOf('=') + 1) === pageName && document.getElementsByClassName('pagination-area')[0]) {
        document.getElementsByClassName('pagination-area')[0].__vue__.currentPage = 1
      }
    }
  })
}
exports.routeByURL = routeByURL
exports.checkURLChanges = checkURLChanges



// WEBPACK FOOTER //
// ./src/methods/routerPagination.js